import { type Application } from 'src/types/application'

import api from 'src/constants/api'

import useAccount from 'src/hooks/utils/useAccount'
import useMutation from 'src/hooks/utils/useMutation'

interface CreateApplicationPayload {
  displayName: string
  permissions: string[]
}

const useCreateApplicationMutation = () => {
  const account = useAccount()

  return useMutation(
    async (payload: CreateApplicationPayload) => {
      const response = await api.post(`graph/account/${account.id}/application`, payload)
      return response.data as Application
    },
    {
      queryKeysToInvalidate: [['applications', account.id]],
      successMessage: 'Application created successfully.',
      errorMessage: 'We were unable to create your application. If the problem persists, please contact support.'
    }
  )
}

export default useCreateApplicationMutation
